export default "__VITE_ASSET__BvIO157x__"